<template>
	<!-- TODO: WHOOHOOOOO INLINESTYLE FOR THE WORLD -->
	<div class="selfordering-login">
		<template
			v-if="!isLoggedIn"
		>
			<FormLogin
				ref="loginForm"
				@loggedIn="onLoggedIn"
			/>
			<FormRegister
				ref="registerForm"
				phone
			/>
		</template>
		<template v-else-if="showPhoneForm">
			<h2 v-html="$t('account.selfordering.addPhoneTitle')"/>
			<p v-html="$t('account.selfordering.addPhoneText')"/>
			<ValidationObserver
				ref="phoneForm"
				v-slot="{ invalid, errors }"
				class=""
				tag="form"
				@submit.prevent="onPhoneUpdate"
				novalidate
			>
				<GeneralMessage
					v-if="phoneResponse.message"
					:message="phoneResponse.message"
					:type="phoneResponse.type"
					@close="phoneResponse.message = ''"
				/>
				<ValidationProvider
					class="input-wrapper"
					name="phone"
					rules="required|phone"
					v-slot="{ errors, invalid, validated }"
					tag="div"
					:customMessages="{ required: $t('forms.errors.fieldEmpty'), phone: $t('forms.errors.phone') }"
				>
					<FormInput
						type="tel"
						:placeholder="$t('forms.labels.phone')"
						:label="$t('forms.labels.phone')"
						v-model="phoneForm.phoneNumber"
						:error="errors.length > 0"
						required
					/>
					<span
						class="input-error"
						v-if="invalid && validated"
						v-html="errors[0]"
					/>
					<span class="additional-info" v-html="$t('login.phoneHint')"/>
				</ValidationProvider>

				<Button
					type="submit"
					level="primary"
					:text="$t('account.safeButton')"
				/>
			</ValidationObserver>
		</template>
		<div class="selfordering-login__details" v-else>
			<h2 v-html="$t('account.selfordering.qrcodeTitle')" />
			<p v-html="$t('account.selfordering.qrcodeText')" />

			<div class="selfordering-login__user">
				<div class="selfordering-login__user-name" v-sanitize="`${accountUserDetail.firstName} ${accountUserDetail.lastName}`"/>
				<div class="selfordering-login__user-email" v-sanitize="accountUserDetail.email"/>
				<div class="selfordering-login__user-phone" v-sanitize="accountUserDetail.phoneNumber"/>
				<Button
					@click.prevent="onPhoneChange"
					level="tertiary"
					type="button"
					:text="$t('account.selfordering.changePhoneButton')"
					arrow
				/>
			</div>

			<QRCode
				:content="accountQrTokenPrefixed"
			/>
			<SVGScanIllustrationPhone/>
		</div>
	</div>
</template>

<script>
import Vue from "vue"
import { mapGetters } from "vuex"
import GenericMixin from '@/mixins/GenericVueMixin';
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormLogin from '@/components/FormLogin';
import FormRegister from '@/components/FormRegister';
import FormInput from '@/components/FormInput';
import GeneralMessage from '@/components/GeneralMessage'
import Button from '@/components/Button';
import QRCode from '@/components/QRCode';
import htmlComponent from 'htmlcomponent'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormLogin,
		FormRegister,
		FormInput,
		GeneralMessage,
		Button,
		QRCode,
	},
	props: {
		overlayType: {
			type: String,
			default() {
				return 'login';
			},
		},
	},
	data() {
		return {
			phoneForm: {
				phoneNumber: '',
			},
			phoneResponse: {
				type: 'info',
				message: '',
			},
			showPhoneForm: false,
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
			"accountQrToken",
			"accountQrTokenPrefixed",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
	},
	watch: {
		isLoggedIn: function(value, oldValue) {
			if (value && value != oldValue) {
				this.onLoggedIn();
			}
		}
	},
	methods: {
		resetForm() {
			this.$refs.loginForm.resetForm();
			this.$refs.registerForm.resetForm();
		},
		async onLoggedIn() {
			this.loading = true;
			this.phoneForm.phoneNumber = this.accountUserDetail.phoneNumber || '';
			this.showPhoneForm = !this.accountUserDetail.phoneNumber;
      try {
        await this.$store.dispatch('account/loadQRToken');
      } catch(err) {
        if (err.isMaintenanceError) {
          this.onMaintenanceMode()
        }
      }
			this.loading = false;
		},
		onPhoneChange() {
			this.phoneForm.phoneNumber = this.accountUserDetail.phoneNumber || '';
			this.showPhoneForm = true;
		},
		async onPhoneUpdate() {
			const isValid = await this.$refs.phoneForm.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
				try {
					await this.$store.dispatch('account/updateUser', {
						...this.accountUserDetail,
						...this.phoneForm,
					})
					this.$refs.phoneForm.reset();
					this.phoneForm.phoneNumber = '';
					this.phoneResponse.message = '';
					this.phoneResponse.type = 'info';
					this.showPhoneForm = false;
				} catch(err) {
          if (err.isMaintenanceError) {
            this.onMaintenanceMode({ callback: () => this.onPhoneUpdate(), retry: true })
          } else {
            let message = err && err.response && err.response.data ? err.response.data.message : this.$t('forms.errors.generic')
            this.phoneResponse.message = message;
            this.phoneResponse.type = 'error';
          }
				}
				this.loading = false;
			}
		},
	},
	created() {
		this.loading = true;
	},
	mounted() {
		this.loading = true;
		if (this.isLoggedIn) {
			this.onLoggedIn();
		}
		this.loading = false;
	}
}
</script>

<style>

</style>
